import React from "react";
import { useTranslation } from "react-i18next";
import { StoreAdminDetails } from "../../../../types/modules/admin/StoreAdmin.type";

type Props = {
  store: StoreAdminDetails;
};

const Availability: React.FC<Props> = ({ store }) => {
  const { t } = useTranslation();
  const { inStore, driveThru } = store;

  return (
    <div className="border-t border-LightGrey3 pt-4">
      <h2 className="text-lg font-semibold text-Black mb-2">{t("availability")}</h2>
      <div className="flex gap-3 flex-wrap">
        <span
          className={`px-4 py-2 rounded-full text-sm ${
            inStore ? "bg-success/10 text-success" : "bg-LightGrey1 text-muted"
          }`}
        >
          {t("inStore")}
        </span>
        <span
          className={`px-4 py-2 rounded-full text-sm ${
            driveThru ? "bg-success/10 text-success" : "bg-LightGrey1 text-muted"
          }`}
        >
          {t("driveThru")}
        </span>
      </div>
    </div>
  );
};

export default Availability;
